<div class="container mobile-padding-0 slots-container">
    <div class="panel main-wrapper">
      <div class="container">
        <div class="row px-4 pt-2">
            <button data-dismiss="modal" id="closetooltipModalButton" class="create-modal-close-icon"
                    aria-label="Close"
                    (click)="close()">
                <svg class="svg-icon svg-icon-Close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.13 19.5">
                    <path d="M13.9,12.2V12l7.7-7.1.1-.1a1.3,1.3,0,0,0-.1-1.9,1.45,1.45,0,0,0-2.1,0L12.1,9.7l-7.5-7a1.57,1.57,0,0,0-2.2,0h0l-.1.1a1.51,1.51,0,0,0,.1,1.9l7.7,7.2v.2L2.4,19.2l-.1.1a1.3,1.3,0,0,0,.1,1.9,1.45,1.45,0,0,0,2.1,0l7.4-6.8,7.5,6.9a1.45,1.45,0,0,0,2.1,0l.1-.1a1.3,1.3,0,0,0-.1-1.9Z"
                          transform="translate(-1.94 -2.25)"/>
                </svg>
            </button>
        </div>
        <div class="body-m body-m-bold mt-3 mb-3">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <h1>
              {{title}}
            </h1>
            <h6>
                <span [innerHTML]="text"></span>
            </h6>
          </div>
          <div class="col-3 close-button-container">
            <button class="close-button btn btn-default" aria-label="Close" (click)="close()">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>